import React from 'react';
import PropTypes from 'prop-types';
import { useGetProductQuery } from '../features/api/openFoodFacts/apiFoodFactsSlice';
import { useGetRatingsByProductListQuery } from '../features/api/rest/apiReviewsSlice';
import ProductCard from './ProductCard';
import { Skeleton } from '@mui/material';

function FavoriteProduct({ ean = '', favorite = false }) {
  const { currentData: productData, isLoading: isProductLoading, isFetching: isProductFetching, isError: isProductError } = useGetProductQuery(ean);
  const {
    ratings,
    isLoading: isRatingLoading,
    isFetching: isRatingFetching,
    isSuccess: isRatingsSuccess,
  } = useGetRatingsByProductListQuery(
    { eans: ean ? ean : skipToken },
    {
      selectFromResult: (result) => ({
        ...result,
        ratings: result.data?.results?.map((rating) => ({
          ean: rating?.ean_code,
          average: rating?.average,
          count: rating.star1 + rating.star2 + rating.star3 + rating.star4 + rating.star5,
        })),
      }),
      skip: !ean,
    }
  );
  const product = productData?.product;

  if (isProductLoading || isRatingLoading || isProductFetching || isRatingFetching) return <Skeleton component="div" />;

  return (
    <ProductCard
      ean={product._id} // eslint-disable-line no-underscore-dangle
      image={product.image_front_small_url}
      name={product.product_name}
      key={product._id} // eslint-disable-line no-underscore-dangle
      rating={ratings?.find((rating) => rating?.ean === product._id)} // eslint-disable-line no-underscore-dangle
      favorite={favorite}
      shouldDisplayRatings={isRatingsSuccess}
    />
  );
}

FavoriteProduct.propTypes = {
  ean: PropTypes.string,
  favorite: PropTypes.bool,
};

export default FavoriteProduct;
